import { DatabaseOutlined, UnorderedListOutlined } from '@ant-design/icons';
import React from 'react';

// 9月份不做数据集管理相关功能
export default {
    path: '/dataset-management',
    code: 'DatasetManagement',
    name: '数据集管理',
    icon: <DatabaseOutlined />,
    routes: [
      {
        path: '/dataset-management',
        hideInMenu: true,
        component: './MenuRedirect',
      },
      {
        path: '/dataset-management/dataset-list',
        code: 'DatasetList',
        name: '数据集',
        icon: <UnorderedListOutlined />,
        component: './DatasetManagement/DatasetList',
      },
    ],
  };
